import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import { Box, Container, Table, TableBody, TableCell, TableHead, TableRow, Button, Grid, Card, CardContent, Typography, Paper, Chip, Pagination, TextField, InputAdornment, IconButton, CircularProgress } from "@mui/material";
import axios from "axios";
import { useEffect, useState, useRef, useCallback } from "react";
import swal from "sweetalert";
import { t } from "i18next";
import { io } from "socket.io-client";
import { useLocation } from "react-router-dom";
import SearchIcon from '@mui/icons-material/Search';
import XocDiaHeaderNav from "../../components/XocDiaHeaderNav";

const API_URL = process.env.REACT_APP_API_URL;
const SOCKET_URL = process.env.REACT_APP_API_URL_SOCKET_TXMD560S || "http://localhost:5000";

function SetXDLive() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const SANH_ID = parseInt(queryParams.get("sanh")) || 1;
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const STREAM_DOMAIN = process.env.REACT_APP_LIVE_STREAM_DOMAIN || "traochoanhmonqua.live";


    const [gameState, setGameState] = useState("waiting");
    const [phien, setPhien] = useState("...");
    const [result, setResult] = useState("...");

    const [totalMoneyChan, setTotalMoneyChan] = useState(0);
    const [totalMoneyLe, setTotalMoneyLe] = useState(0);
    const [totalUserChan, setTotalUserChan] = useState(0);
    const [totalUserLe, setTotalUserLe] = useState(0);
    const [usersChan, setUsersChan] = useState([]);
    const [usersLe, setUsersLe] = useState([]);

    const [listSessionHistory, setListSessionHistory] = useState([]);
    const [listPlayerHistory, setListPlayerHistory] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchKeyword, setSearchKeyword] = useState("");
    const [isLoadingHistory, setIsLoadingHistory] = useState(false);

    const socketRef = useRef();

    function formatDateTimeFull(dateStr) {
        const m = new Date(dateStr);
        if (isNaN(m.getTime())) return "";
        return (
            ("0" + m.getDate()).slice(-2) + "/" +
            ("0" + (m.getMonth() + 1)).slice(-2) + "/" +
            m.getFullYear() + " " +
            ("0" + m.getHours()).slice(-2) + ":" +
            ("0" + m.getMinutes()).slice(-2) + ":" +
            ("0" + m.getSeconds()).slice(-2)
        );
    }

    const fetchCurrentBets = useCallback(() => {
        const token = localStorage.getItem("token");
        axios.get(`${API_URL}/history/live/xd/current`, {
            headers: { Authorization: `Bearer ${token}` }
        }).then((res) => {
            if (res.data.success && res.data.data) {
                const { session, bets } = res.data.data;
                if (session) {
                    setPhien(session.id_bet);
                    setResult(session.result || "...");
                    setTotalMoneyChan(session.total_money_chan || 0);
                    setTotalMoneyLe(session.total_money_le || 0);
                    setTotalUserChan(session.total_users_chan || 0);
                    setTotalUserLe(session.total_users_le || 0);
                }
                if (bets) {
                    const listChan = bets.filter(b => b.state === "chan" || b.state === "5" || (b.state && b.state.split(" ").some(s => s === "chan" || s === "5")));
                    const listLe = bets.filter(b => b.state === "le" || b.state === "6" || (b.state && b.state.split(" ").some(s => s === "le" || s === "6")));
                    setUsersChan(listChan);
                    setUsersLe(listLe);
                }
            }
        }).catch(() => { });
    }, []);

    useEffect(() => {
        socketRef.current = io(SOCKET_URL, { transports: ["websocket"] });

        socketRef.current.on("xocdia_live_time", (data) => {

            if (data.state) {
                setGameState(data.state);
            }
            if (data.data) {
                setPhien(data.data.id_bet);
            }
            // Dùng lastResult từ server để hiển thị kết quả phiên trước (không bị mất khi phiên mới bắt đầu)
            if (data.lastResult && data.lastResult.result) {
                setResult(data.lastResult.result);
            } else if (data.data && data.data.result) {
                setResult(data.data.result);
            }
        });

        socketRef.current.on("xocdia_live_new_session", (data) => {
            setPhien(data.id_bet);
            setGameState("betting");
            // Không reset result ở đây - giữ kết quả phiên trước
            setTotalMoneyChan(0); setTotalMoneyLe(0);
            setTotalUserChan(0); setTotalUserLe(0);
            setUsersChan([]); setUsersLe([]);
        });

        socketRef.current.on("xocdia_live_result", (data) => {
            setResult(data.result);
            fetchHistorySession();
        });

        fetchCurrentBets();
        fetchHistorySession();
        fetchPlayerHistory(1, "");

        // Interval to refresh current bets in active session
        const interval = setInterval(() => {
            fetchCurrentBets();
        }, 3000);

        return () => {
            if (socketRef.current) socketRef.current.disconnect();
            clearInterval(interval);
        };
    }, [fetchCurrentBets]);

    const fetchPlayerHistory = (pageNum, keyword) => {
        setIsLoadingHistory(true);
        const token = localStorage.getItem("token");
        const query = keyword ? `&username=${keyword}` : "";
        axios.get(`${API_URL}/history/live/xd/history-all-players?page=${pageNum}&limit=10${query}`, {
            headers: { Authorization: `Bearer ${token}` }
        }).then((res) => {
            if (res.data.success) {
                setListPlayerHistory(res.data.data.data);
                setTotalPages(res.data.data.totalPages || 1);
            }
        }).catch((err) => console.log(err))
            .finally(() => setIsLoadingHistory(false));
    };

    const fetchHistorySession = () => {
        const token = localStorage.getItem("token");
        axios.get(`${API_URL}/history/live/xd/getallbet?limit=20`, {
            headers: { Authorization: `Bearer ${token}` }
        }).then((res) => {
            if (res.data.success) {
                setListSessionHistory(res.data.data);
            }
        }).catch(() => { });
    };

    const handleSearch = () => {
        setPage(1);
        fetchPlayerHistory(1, searchKeyword);
    };

    const formatMoney = (n) => String(n ? Math.floor(n / 1000) : 0).replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    const UserListTable = ({ users, title, color }) => (
        <Paper sx={{ maxHeight: 300, overflow: 'auto', bgcolor: '#f5f5f5', border: `1px solid ${color}` }}>
            <Table size="small" stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ fontWeight: 'bold', color: color, bgcolor: '#eee' }}>User ({users.length})</TableCell>
                        <TableCell sx={{ fontWeight: 'bold', color: color, textAlign: 'right', bgcolor: '#eee' }}>Tiền</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {users && users.length > 0 ? (
                        users.map((u, i) => (
                            <TableRow key={i}>
                                <TableCell>{u.user?.username || "Ẩn danh"}</TableCell>
                                <TableCell align="right" sx={{ fontWeight: 'bold', color: '#333' }}>{formatMoney(u.money)}</TableCell>
                            </TableRow>
                        ))
                    ) : (
                        <TableRow><TableCell colSpan={2} align="center" sx={{ color: '#aaa', py: 3 }}>Trống</TableCell></TableRow>
                    )}
                </TableBody>
            </Table>
        </Paper>
    );

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                <Box component="main" className="blockchain-admin-page happy-classic-game happy-classic-xocdia" sx={{ flexGrow: 1, py: 2, bgcolor: '#f4f6f8', minHeight: '100vh' }}>
                    <Container maxWidth={false}>
                        <XocDiaHeaderNav currentMode="xdlive" currentSanh={SANH_ID} />

                        {profile?.permission?.set === 1 ? (
                            <>
                                <div className="container_set" style={{ fontSize: '28px', fontWeight: '900', marginBottom: '20px', textAlign: 'center', color: '#10B981', textTransform: 'uppercase' }}>
                                GIÁM SÁT XÓC ĐĨA LIVE (SẢNH {SANH_ID})
                            </div>

                            <Grid container spacing={2} sx={{ mb: 2 }}>
                                {/* Livestream View */}
                                <Grid item xs={12} md={7}>
                                    <Card sx={{ border: '1px solid #ddd', height: '100%', boxShadow: 2 }}>
                                        <CardContent sx={{ p: 1, '&:last-child': { pb: 1 } }}>
                                            <Typography variant="h6" align="center" sx={{ fontWeight: 'bold', mb: 1, color: '#333' }}>LUỒNG LIVE STREAM</Typography>
                                            <div style={{ position: 'relative', width: '100%', paddingTop: '56.25%', borderRadius: '8px', overflow: 'hidden', border: '1px solid #ccc' }}>
                                                <iframe
                                                    src={process.env.REACT_APP_LIVE_STREAM_XD || "https://traochoanhmonqua.live/XocDia_Hitclub.html"}
                                                    title="Live Stream"
                                                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                                                    allow="autoplay"
                                                    scrolling="no"
                                                />
                                            </div>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                {/* Current Status */}
                                <Grid item xs={12} md={5}>
                                    <Card sx={{ border: '1px solid #ddd', height: '100%', boxShadow: 2 }}>
                                        <CardContent sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '100%' }}>
                                            <div style={{ textAlign: 'center' }}>
                                                <Typography variant="h6" color="textSecondary">PHIÊN HIỆN TẠI</Typography>
                                                <Typography variant="h3" color="primary" sx={{ fontWeight: 'bold', mb: 1 }}>#{phien}</Typography>
                                                <div style={{
                                                    fontSize: '28px',
                                                    fontWeight: 'bold',
                                                    color: gameState === 'betting' ? '#10B981' : gameState === 'stopped' ? '#D32F2F' : '#F59E0B',
                                                    marginBottom: '15px',
                                                    textTransform: 'uppercase',
                                                    letterSpacing: '0.5px'
                                                }}>
                                                    {gameState === 'betting' ? 'Nhận cược' : gameState === 'stopped' ? 'Dừng cược' : 'Đang mở bát'}
                                                </div>
                                                <Typography variant="h6" color="textSecondary" sx={{ mt: 2 }}>KẾT QUẢ PHIÊN TRƯỚC</Typography>
                                                <Typography variant="h4" color="secondary" sx={{ fontWeight: 'bold', textTransform: 'uppercase' }}>
                                                    {result || "..."}
                                                </Typography>
                                            </div>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>

                            {/* Live Betting Pools */}
                            <Grid container spacing={2} sx={{ mb: 4 }}>
                                <Grid item xs={12} md={6}>
                                    <Card sx={{ bgcolor: '#fff', borderTop: '5px solid #1976D2', boxShadow: 2 }}>
                                        <CardContent>
                                            <Box sx={{ textAlign: 'center', mb: 1, bgcolor: '#1976D2', p: 1, borderRadius: 1, color: '#fff' }}>
                                                <Typography variant="h5" sx={{ fontWeight: 'bold' }}>CHẴN - <span style={{ color: '#10B981' }}>{formatMoney(totalMoneyChan)}</span></Typography>
                                            </Box>
                                            <UserListTable users={usersChan} title="Chẵn" color="#1976D2" />
                                        </CardContent>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Card sx={{ bgcolor: '#fff', borderTop: '5px solid #d32f2f', boxShadow: 2 }}>
                                        <CardContent>
                                            <Box sx={{ textAlign: 'center', mb: 1, bgcolor: '#d32f2f', p: 1, borderRadius: 1, color: '#fff' }}>
                                                <Typography variant="h5" sx={{ fontWeight: 'bold' }}>LẺ - <span style={{ color: '#FFEB3B' }}>{formatMoney(totalMoneyLe)}</span></Typography>
                                            </Box>
                                            <UserListTable users={usersLe} title="Lẻ" color="#d32f2f" />
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>

                            {/* Player Bets History */}
                            <Grid container spacing={2} sx={{ mt: 2 }}>
                                <Grid item xs={12}>
                                    <Card sx={{ height: '100%', border: '1px solid #10B981', boxShadow: 3 }}>
                                        <CardContent>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                            <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#10B981', fontSize: '16px' }}>LỊCH SỬ CƯỢC LIVE (NGƯỜI CHƠI)</Typography>
                                                <Box sx={{ display: 'flex', gap: 1 }}>
                                                    <TextField
                                                        size="small" placeholder="Tìm username..."
                                                        value={searchKeyword} onChange={(e) => setSearchKeyword(e.target.value)} onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                                                        InputProps={{ endAdornment: (<InputAdornment position="end"><IconButton onClick={handleSearch}><SearchIcon /></IconButton></InputAdornment>) }}
                                                    />
                                                </Box>
                                            </Box>
                                            <Box sx={{ overflowX: 'auto', minHeight: 300 }}>
                                                {isLoadingHistory ? <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}><CircularProgress /></Box> : (
                                                    <Table size="small">
                                                        <TableHead><TableRow sx={{ bgcolor: '#E0F2F1' }}>
                                                            <TableCell>Thời gian</TableCell>
                                                            <TableCell>Người chơi</TableCell>
                                                            <TableCell>Phiên</TableCell>
                                                            <TableCell align="center">Cửa</TableCell>
                                                            <TableCell align="right">Tiền cược</TableCell>
                                                            <TableCell align="right">Tiền thắng</TableCell>
                                                            <TableCell align="center">Trạng thái</TableCell>
                                                        </TableRow></TableHead>
                                                        <TableBody>
                                                            {listPlayerHistory && listPlayerHistory.length > 0 ? listPlayerHistory.map((item) => (
                                                                <TableRow key={item._id} hover>
                                                                    <TableCell style={{ fontSize: '12px' }}>{formatDateTimeFull(item.createdAt)}</TableCell>
                                                                    <TableCell sx={{ fontWeight: 'bold', color: '#1976D2' }}>{item.user ? item.user.username : '...'}</TableCell>
                                                                    <TableCell>#{item.id_bet ? item.id_bet.id_bet : '...'}</TableCell>
                                                                    <TableCell align="center">
                                                                        {(() => {
                                                                            const states = item.state ? item.state.split(" ") : [];
                                                                            const isChanBet = states.some(s => s === "chan" || s === "5" || s === "2" || s === "1");
                                                                            const isLeBet = states.some(s => s === "le" || s === "6" || s === "3" || s === "4");
                                                                            const label = isChanBet && !isLeBet ? "Chẵn" 
                                                                                        : isLeBet && !isChanBet ? "Lẻ" 
                                                                                        : states.map(s => s==="5"||s==="chan"?"Chẵn":s==="6"||s==="le"?"Lẻ":s==="1"?"4Đỏ":s==="2"?"4Trắng":s==="3"?"3Đỏ":s==="4"?"3Trắng":s).join(", ");
                                                                            const color = isChanBet && !isLeBet ? "primary" : isLeBet && !isChanBet ? "error" : "default";
                                                                            return <Chip label={label} color={color} size="small" sx={{ fontWeight: 'bold' }} />;
                                                                        })()}
                                                                    </TableCell>
                                                                    <TableCell align="right">{formatMoney(item.money)}</TableCell>
                                                                    <TableCell align="right" sx={{ color: 'green', fontWeight: 'bold' }}>
                                                                        {item.moneythang > 0 ? `+${formatMoney(item.moneythang)}` : "0"}
                                                                    </TableCell>
                                                                    <TableCell align="center">
                                                                        <Chip
                                                                            label={item.status_bet === "Win" ? "Thắng" : item.status_bet === "Lose" ? "Thua" : "Chờ"}
                                                                            color={item.status_bet === "Win" ? "success" : item.status_bet === "Lose" ? "default" : "warning"}
                                                                            size="small"
                                                                        />
                                                                    </TableCell>
                                                                </TableRow>
                                                            )) : <TableRow><TableCell colSpan={7} style={{ textAlign: "center", padding: 20 }}>Không tìm thấy dữ liệu</TableCell></TableRow>}
                                                        </TableBody>
                                                    </Table>
                                                )}
                                            </Box>
                                            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                                                <Pagination
                                                    count={totalPages}
                                                    page={page}
                                                    onChange={(e, val) => {
                                                        setPage(val);
                                                        fetchPlayerHistory(val, searchKeyword);
                                                    }}
                                                    color="primary"
                                                    size="small"
                                                />
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>

                            {/* Past Sessions List */}
                            <Grid container spacing={2} sx={{ mt: 2 }}>
                                <Grid item xs={12}>
                                    <Card sx={{ height: '100%', border: '1px solid #ddd' }}>
                                        <CardContent>
                                            <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', fontSize: '16px' }}>LỊCH SỬ PHIÊN (20 Phiên gần nhất)</Typography>
                                            <Box sx={{ overflowX: 'auto' }}>
                                                <Table size="small" padding="none">
                                                    <TableHead><TableRow sx={{ bgcolor: '#eee' }}>
                                                        <TableCell align="center" sx={{ p: 1 }}>Phiên</TableCell>
                                                        <TableCell align="center" sx={{ p: 1 }}>Kết quả</TableCell>
                                                        <TableCell align="center" sx={{ p: 1 }}>Trạng thái</TableCell>
                                                        <TableCell align="center" sx={{ p: 1 }}>Thời gian</TableCell>
                                                    </TableRow></TableHead>
                                                    <TableBody>
                                                        {listSessionHistory.map((item) => {
                                                            const vis = item.result ? item.result.split(" ").map(Number) : [];
                                                            const redCount = vis.filter(v => v === 1).length;
                                                            const isChan = redCount % 2 === 0;
                                                            return (
                                                                <TableRow key={item._id} hover>
                                                                    <TableCell align="center" sx={{ fontWeight: 'bold', fontSize: '13px', p: 1 }}>#{item.id_bet}</TableCell>
                                                                    <TableCell align="center" sx={{ p: 1 }}>
                                                                        <span style={{ fontSize: '14px', fontWeight: 'bold', color: isChan ? '#1976d2' : '#d32f2f' }}>
                                                                            {item.result || "..."}
                                                                        </span>
                                                                    </TableCell>
                                                                    <TableCell align="center" sx={{ fontWeight: 'bold', fontSize: '13px', color: isChan ? '#1976d2' : '#d32f2f', p: 1 }}>
                                                                        {item.result ? `${isChan ? 'Chẵn' : 'Lẻ'} (${redCount} Đỏ)` : '...'}
                                                                    </TableCell>
                                                                    <TableCell align="center" sx={{ fontSize: '12px', p: 1 }}>{formatDateTimeFull(item.createdAt)}</TableCell>
                                                                </TableRow>
                                                            );
                                                        })}
                                                    </TableBody>
                                                </Table>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>
                            </>
                        ) : (
                            <div style={{ padding: 20, textAlign: 'center' }}>{t('not_permission')}</div>
                        )}
                    </Container>
                </Box>
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default SetXDLive;
